export default __webpack_public_path__ + "images/datatables_sort_asc.png?3d6f9b3fb9285c14dfb884a15a13cb99";